import { store } from "../store.js";

class Parsers {
  _cache = {};

  constructor() {
    store.set("parsers", this._cache);
  }

  hasType(name) {
    return name in this._cache;
  }

  addType(namespace, function_) {
    this._cache[namespace] = function_;
  }

  getType(namespace) {
    return this._cache[namespace];
  }
}

const parsers = new Parsers();
export { Parsers, parsers };
